import _ from 'lodash'

export const SET_DELIVERY_ZIPCODE = (state, zipcode) => {
  state.deliveryZipcode = zipcode
}

export const setAuthRedirect = (state, url) => {
  state.authRedirect = url
}

export const SHOULD_RESTORE_ORDER = (state, status) => {
  state.order.shouldRestore = status
}

export const SET_AUTH_BEHAVIOR_TYPE = (state, type) => {
  state.authBehavior = type
}

export const SET_ORDER_BEHAVIOR_TYPE = (state, type) => {
  state.orderBehavior = type
}

export const setNotificationStatus = (state, status) => {
  state.isNotificationShown = !!status
}

export const SET_ORDER_COLLABORATOR_INVITATION = (state, caterer) => {
  state.orderCollaboratorInvitations.push(caterer)
}
export const RESET_ORDER_COLLABORATOR_INVITATION = (state) => {
  state.orderCollaboratorInvitations = []
}

/**
 * Authentication
 * @param {*} state
 * @param {*} data {user: {}, token: ""}
 */
export const SET_AUTH_DATA = (state, data) => {
  state.auth = data
  localStorage.setItem('access_token', data.token)
  localStorage.setItem('user', JSON.stringify(data.user))
}

export const SET_USER_INFO = (state, data) => {
  state.auth.user = data
}

export const SET_USER_GROUPS = (state, groups) => {
  state.auth.groups = groups
}

export const VERIFY_EMAIL = (state) => {
  state.auth.user = state.auth.user.update({ verified: true })
}

export const CLEAR_AUTH_DATA = (state,) => {
  state.auth = { user: null, token: null }
  localStorage.removeItem('access_token')
  localStorage.removeItem('user')
}

export const SET_AUTH_TOKEN = (state, token) => {
  state.auth.token = token
}

// Order
export const SET_CURRENT_STEP = (state, step) => {
  state.currentStep = step
}

export const SET_CURRENT_ORDER = (state, order) => {
  state.order.current = order
}

export const UPDATE_CURRENT_ORDER = (state, order) => {
  state.order.current = state.order.current?.update(order)
}

export const setCurrentOrder = (state, order) => {
  state.order.current = order
}

export const setCurrentOrderErrors = (state, errors) => {
  state.order.errors = { ...errors?.errors }
}

export const setClientSecret = (state, secret) => {
  state.order.clientSecret = secret
}

// Order messages
export const setOrderMessages = (state, messages) => {
  state.orderMessages.list = messages
  state.orderMessages.loaded = true
}

export const ADD_ORDER_MESSAGE = (state, message) => {
  state.orderMessages.list = [...state.orderMessages.list, message]
}

export const ORDER_MESSAGE_CREATED = (state, status = true) => {
  state.orderMessages.created = status
}

export const UPDATE_ORDER_MESSAGE = (state, message) => {
  const _message = state.orderMessages.list.find(_message => _message.id === message.id)
  Object.assign(_message, message)
}

export const UPDATE_ORDER_MESSAGE_ID = (state, { message, id }) => {
  const _messages = state.orderMessages.list.filter(msg => msg.dependsOn === id)
  _messages.forEach(msg => msg.update({ dependsOn: message.id }))
  state.orderMessages.list = [...state.orderMessages.list]
}

export const DELETE_ORDER_MESSAGE = (state, id) => {
  state.orderMessages.list = state.orderMessages.list.filter(msg => msg.id !== id)
}

// Message Builder
export const setMessageBuilderConfig = (state, config) => {
  state.messageBuilder = { ...config }
}

export const updateCurrentMessage = (state, message) => {
  state.messageBuilder.message = {
    ...state.messageBuilder.message,
    ...message
  }
}

// Order Characters
export const SET_ORDER_CHARACTERS = (state, characters) => {
  state.orderCharacters.list = [...characters]
  state.orderCharacters.loaded = true
}

export const SET_ORDER_SELECTED_CHARACTERS = (state, characters) => {
  state.orderCharacters.selected = [...characters]
}

export const SET_DEFAULT_CHARACTERS = (state, characters) => {
  state.defaultCharacters.list = [...characters]
  state.defaultCharacters.loaded = true
}

export const ADD_ORDER_CHARACTER = (state, character) => {
  state.orderCharacters.list = [...state.orderCharacters.list, character]
}

export const EDIT_ORDER_CHARACTER = (state, character) => {
  const _character = state.orderCharacters.list.find(_character => _character.id === character.id)
  Object.assign(_character, _character.update(character))
}

// Order Characters
export const setOrderCharacters = (state, characters) => {
  state.orderCharacters.list = characters
  state.orderCharacters.loaded = true
}

export const setSelectedCharactersIds = (state, ids) => {
  state.selectedCharacters = [...ids]
}

export const setDefaultCharacters = (state, characters) => {
  state.defaultCharacters.list = characters
  state.defaultCharacters.loaded = true
}

export const addOrderCharacter = (state, character) => {
  state.orderCharacters.list = [...state.orderCharacters.list, character]
}

export const updateOrderCharacters = (state, characters) => {
  state.orderCharacters.list = state.orderCharacters.list.map((character, index) => character.update(characters[index]))
}

export const openCharacter = (state, character) => {
  state.orderCharacters.current = character
  state.orderCharacters.edit = false
}

export const openCharacterToEdit = (state, character) => {
  state.orderCharacters.current = character
  state.orderCharacters.edit = true
}

export const closeCharacter = (state) => {
  state.orderCharacters.current = null
  state.orderCharacters.edit = false
  document.body.style.overflow = 'auto'
}

export const uploadCharacterImage = (state, data) => {
  state.orderCharacters.current.uploadImage(data)
}

export const completeOrderAttendees = (state) => {
  state.orderAttendees.complete = true
}

export const DELETE_CHARACTER = (state, id) => {
  state.orderCharacters.list = state.orderCharacters.list.filter(character => character.id !== id)
}

export const SELECT_ORDER_CHARACTER = (state, character) => {
  state.orderCharacters.selected = [...state.orderCharacters.selected, character]
}

export const UNSELECT_ORDER_CHARACTER = (state, character) => {
  state.orderCharacters.selected = [...state.orderCharacters.selected.filter(ch => ch.id !== character.id)]
}

export const SAVE_ORDER_CHARACTERS = (state, characters) => {
  state.orderCharacters.list = characters
}

// Order Attendees
export const setOrderAttendees = (state, attendees) => {
  if (attendees) {
    state.orderAttendees.list = attendees

    if (attendees.length) {
      state.orderAttendees.complete = true
    }
  }

  state.orderAttendees.loaded = true
}

export const uploadCSV = (state, status) => {
  state.orderAttendees.CSVuploaded = !!status
}

export const COMPLETE_ORDER = (state, status) => {
  state.order.complete = status
}

export const addOrderAttendee = (state, attendee) => {
  state.orderAttendees.list = [...state.orderAttendees.list, attendee]
  state.orderAttendees.CSVuploaded = false
}

export const updateOrderAttendee = (state, attendee) => {
  const _attendee = state.orderAttendees.list.find(_attendee => _attendee.id === attendee.id)
  Object.assign(_attendee, attendee)
  state.orderAttendees.CSVuploaded = false
}

export const DELETE_ATTENDEE = (state, id) => {
  state.orderAttendees.list = state.orderAttendees.list.filter(attendee => attendee.id !== id)
}

export const SET_ORDER_DETAILS = (state, details) => {
  state.orderDetails.details = details
}

export const SET_ORDER_DETAILS_VALID_STATUS = (state, status) => {
  state.orderDetails.valid = status
}

export const SET_ORDER_MENU = (state, menu) => {
  state.menu.menu = { ...menu }
}

export const SET_ORDER_SELECTED_MENU = (state, menu) => {
  state.menu.selectedMenu = [...menu]
}

export const MENU_CREATED = (state, status = true) => {
  state.menu.created = status
}

export const SELECT_MENU_ITEM = (state, { item, category }) => {
  const _category = state.menu.selectedMenu.find(ct => ct.id === category.id)
  const _item = { ...item }
  _category.items.push(_item)
  state.menu.selectedMenu = [...state.menu.selectedMenu]
}

export const UNSELECT_MENU_ITEM = (state, { item, category }) => {
  const _category = state.menu.selectedMenu.find(ct => ct.id === category.id)
  _category.items = _category.items.filter(it => it.id !== item.id)
  state.menu.selectedMenu = [...state.menu.selectedMenu]
}

export const SET_EVENT_CHARACTERS = (state, characters) => {
  state.attendeeOrderCharacters = characters
}

// Categories

export const SET_ORDER_CATEGORIES = (state, categories) => {
  state.orderCategories.categories = [..._.orderBy(categories, 'position')]
}

export const SET_ORDER_CATEGORIES_POSITIONS = (state, categories) => {
  categories.forEach((item, index) => {
    item.position = index
  })
  state.orderCategories.categories = [..._.orderBy(categories, 'position')]
}

export const openCategory = (state, category) => {
  state.orderCategories.current = category
  state.orderCategories.edit = false
}

export const openCategoryToEdit = (state, category) => {
  state.orderCategories.current = category
  state.orderCategories.edit = true
}

export const closeCategory = (state) => {
  state.orderCategories.current = null
  state.orderCategories.edit = false
  document.body.style.overflow = 'auto'
}

export const ADD_ORDER_CATEGORY = (state, category) => {
  state.orderCategories.categories[Object.keys(state.orderCategories.categories).length] = category
}

export const EDIT_ORDER_CATEGORY = (state, category) => {
  const _category = state.orderCategories.categories.find(_category => _category.id === category.id)
  Object.assign(_category, _category.update(category))
}

export const update_select_category = (state, category) => {
  category.selected = !category.selected
  let allSelect = true
  state.orderCategories.categories.forEach((element) => {
    if (!element.selected) {
      allSelect = false
    }
  })
  allSelect ? state.orderCategories.allSelected = true : state.orderCategories.allSelected = false
}

export const delete_category = (state, category) => {
  let catIndex
  state.orderCategories.categories.forEach((element, index) => {
    if (element.id == category.id) {
      catIndex = index
    }
  })
  state.orderCategories.categories.splice(catIndex, 1)
  if (!state.orderCategories.categories.length) {
    state.orderCategories.allSelected = false
  }
}

export const delete_selected_categories = (state) => {
  let indexList = []
  state.orderCategories.categories.forEach((element, index) => {
    if (element.selected) {
      indexList.push(index)
    }
  })

  indexList.slice().reverse().forEach((item) => {
    state.orderCategories.categories.splice(item, 1)
  })

  if (!state.orderCategories.categories.length) {
    state.orderCategories.allSelected = false
  }
}

export const select_unselect_all = (state, selectState) => {
  if (selectState == 'select') {
    state.orderCategories.categories.forEach((category) => {
      category.selected = true
    })
    state.orderCategories.allSelected = true
  } else if (selectState == 'unselect') {
    state.orderCategories.categories.forEach((category) => {
      category.selected = false
    })
    state.orderCategories.allSelected = false
  } else {
    state.orderCategories.categories.forEach((category) => {
      category.selected = !state.orderCategories.allSelected
    })
    state.orderCategories.allSelected = !state.orderCategories.allSelected
  }
}

export const uploadCategoryImage = (state, data) => {
  state.orderCategories.current.uploadImage(data)
}

export const setCategoryName = (state, props) => {
  state.orderCategories.categories.forEach((item) => {
    if (item.id == props.id) {
      item.setName(props.name)
    }
  })
}
//Finish Categories

//LineItems

export const SET_ORDER_LINE_ITEMS = (state, lineItems) => {
  state.orderlineItems.lineItems = [..._.orderBy(lineItems, 'position')]
}

export const SET_ORDER_LINE_ITEMS_POSITIONS = (state, props) => {
  props.lineItems.forEach((item, index) => {
    item.position = index
  })
  state.orderlineItems.lineItems[props.indexCategory].items = [..._.orderBy(props.lineItems, 'position')]
}

export const openLineItem = (state, lineItems) => {
  state.orderlineItems.current = lineItems
  state.orderlineItems.edit = false
}

export const openLineItemToEdit = (state, lineItems) => {
  state.orderlineItems.current = lineItems
  state.orderlineItems.edit = true
}

export const closeLineItem = (state) => {
  state.orderlineItems.current = null
  state.orderlineItems.edit = false
  document.body.style.overflow = 'auto'
}

export const ADD_ORDER_LINE_ITEM = (state, lineItem) => {
  let indexCat
  state.orderlineItems.lineItems.forEach((item, index) => {
    if (item.id == lineItem.category) {
      indexCat = index
    }
  })
  state.orderlineItems.lineItems[indexCat].items.push(lineItem)
}

export const EDIT_ORDER_LINE_ITEM = (state, { lineItem, indexCategory }) => {
  const _lineItem = state.orderlineItems.lineItems[indexCategory].items.find(_lineItem => _lineItem.id === lineItem.id)
  Object.assign(_lineItem, _lineItem.update(lineItem))
}

export const update_select_lineItem = (state, lineItem) => {
  lineItem.selected = !lineItem.selected
}

export const delete_lineItem = (state, props) => {
  let lineIndex
  state.orderlineItems.lineItems[props.indexCategory].items.forEach((element, index) => {
    if (element.id == props.lineItem.id) {
      lineIndex = index
    }
  })
  state.orderlineItems.lineItems[props.indexCategory].items.splice(lineIndex, 1)
}

export const delete_selected_lineItems = (state, indexCategory) => {
  let indexList = []
  state.orderlineItems.lineItems[indexCategory].items.forEach((element, index) => {
    if (element.selected) {
      indexList.push(index)
    }
  })

  indexList.slice().reverse().forEach((item) => {
    state.orderlineItems.lineItems[indexCategory].items.splice(item, 1)
  })
}

export const select_unselect_all_lineItems = (state, props) => {
  if (props.selectState == 'select') {
    state.orderlineItems.lineItems[props.indexCategory].items.forEach((lineItem) => {
      lineItem.selected = true
    })
  } else if (props.selectState == 'unselect') {
    state.orderlineItems.lineItems[props.indexCategory].items.forEach((lineItem) => {
      lineItem.selected = false
    })
  } else if (props.selectState == null) {
    state.orderlineItems.lineItems[props.indexCategory].items.forEach((lineItem) => {
      lineItem.selected = !props.allSelected
    })
  }
}

export const uploadLineItemImage = (state, data) => {
  state.orderlineItems.current.uploadImage(data)
}

//Finish Line Items

export const SET_ITEM_DEFAULT = (state, { item, category }) => {
  let _category = state.menu.selectedMenu.find(ct => ct.id === category.id)
  let _item = _category.items.find(it => it.id === item.id)
  _item.isDefault = true
  state.menu.selectedMenu = [...state.menu.selectedMenu]
}

export const SET_ITEM_NOT_DEFAULT = (state, { item, category }) => {
  let _category = state.menu.selectedMenu.find(ct => ct.id === category.id)
  let _item = _category.items.find(it => it.id === item.id)
  _item.isDefault = false
  state.menu.selectedMenu = [...state.menu.selectedMenu]
}

export const SET_ORDER_DETAILS_EDITED_STATUS = (state, status) => {
  state.orderDetails.touched = status
}

export const SET_ORDER_DETAILS_ERRORS = (state, errors) => {
  state.orderDetails.errors = errors
}

export const SET_ERROR_MESSAGE = (state, message) => {
  if (state.success) state.success = null
  state.error = message
}

export const SET_SUCCESS_MESSAGE = (state, message) => {
  if (state.error) state.error = null
  state.success = message
}

export const HIDE_ERROR_MESSAGE = (state) => {
  state.error = null
}

export const SET_ORDER_MENU_EDITED_STATUS = (state, status) => {
  state.menu.touched = status
}

export const SET_ORDER_MENU_ERRORS = (state, errors) => {
  state.menu.errors = { ...errors }
}

export const SET_ORDER_CHARACTERS_EDITED_STATUS = (state, status) => {
  state.orderCharacters.edited = status
}

export const SET_ORDER_ATTENDEES_EDITED_STATUS = (state, status) => {
  state.orderAttendees.edited = status
}

export const SET_ORDER_ATTENDEES_TOUCHED_STATUS = (state, status) => {
  state.orderAttendees.touched = status
}

export const ORDER_ATTENDEES_CREATED = (state, status) => {
  state.orderAttendees.created = status
}

export const SET_ORDER_ATTENDEES_ERRORS = (state, errors) => {
  state.orderAttendees.errors = errors
}

export const setMenu = (state, menu) => {
  if (menu) {
    state.menu.categories = menu
  }

  state.menu.loaded = true
}

export const setIsNewOrder = (state, value) => {
  state.isNewOrder = value
}

// Attendee
export const setAttendeeAuthData = (state, data) => {
  state.attendeeAuth.user = data.user
  state.attendeeAuth.token = data.token
}

export const updateCurrentSubOrder = (state, order) => {
  state.subOrder.current = state.subOrder.current?.update(order)
}

export const setAttendeeCharacter = (state, character) => {
  state.subOrder.character = character
}

export const setAttendeeSubOrderEventDetails = (state, event) => {
  state.subOrder.event = event
}

export const CONTINUE_ORDER_AFTER_AUTH = (state, status = true) => {
  state.order.continueAfterAuth = status
}

export const CLEAR_ORDER = state => {
  state.deliveryZipcode = ''
  state.delays = []
  state.currentStep = 0

  state.order = {
    complete         : false,
    shouldRestore    : false,
    loaded           : false,
    list             : [],
    current          : null,
    clientSecret     : null,
    errors           : null,
    details          : null,
    menu             : null,
    menuEdited       : false,
    detailsEdited    : false,
    continueAfterAuth: false
  }

  state.orderDetails = {
    details: null,
    valid  : false,
    touched: false,
    errors : {}
  }

  state.menu = {
    menu        : null,
    selectedMenu: null,
    created     : false,
    loaded      : false,
    valid       : false,
    touched     : false,
    errors      : {}
  }

  state.orderMessages = {
    loaded : false,
    list   : [],
    current: null,
    created: false,
  }

  state.orderCharacters = {
    loaded  : false,
    list    : [],
    selected: [],
    current : null,
    edit    : false,
    edited  : false,
  }

  state.orderAttendees = {
    loaded     : false,
    complete   : false,
    CSVuploaded: false,
    edited     : false,
    list       : [],
    valid      : false,
    errors     : {},
    touched    : false,
    created    : false,
  }

  state.defaultCharacters = {
    loaded: false,
    list  : []
  }
}

// =========== ATTENDEE ===========
// TODO: will be better to move out this to modules

export const setAddress = (state, address) => {
  state.deliveryAddress = address
}

export const setTransition = (state, transition) => {
  state.transition = transition
}

export const addMessageDelay = (state, delay) => {
  state.delays = [...state.delays.filter(d => d.id !== delay.id), delay]
}

export const clearMessageDelays = state => {
  state.delays = []
}

// Authentication
export const setAuthData = (state, data) => {
  state.attendeeAuth = data
  localStorage.setItem('attendee_access_token', data.token)
  localStorage.setItem('user', JSON.stringify(data.user))
}

export const clearAuthData = (state,) => {
  state.attendeeAuth = { user: null, token: null }
  localStorage.removeItem('attendee_access_token')
  localStorage.removeItem('user')
}

export const setAuthToken = (state, token) => {
  state.attendeeAuth.token = token
}

// Order
export const updateCurrentOrder = (state, order) => {
  state.order.current = state.order.current?.update(order)
}

// Order messages
export const addOrderMessage = (state, message) => {
  state.orderMessages.list = [...state.orderMessages.list, message]
}

export const updateOrderMessage = (state, message) => {
  const _message = state.orderMessages.list.find(_message => _message.id === message.id)
  Object.assign(_message, message)
}

export const updateOrderCharacter = (state, character) => {
  const _character = state.orderCharacters.list.find(_character => _character.id === character.id)
  Object.assign(_character, _character.update(character))
}

export const SET_ORDER_MESSAGE_TRIGGER = (state, triggers) => {
  state.orderMessages.trigger = [...triggers]
}

// Order Attendees
export const SET_ORDER_MENU_ATTENDEE = (state, menu) => {
  state.order.menu = menu
}

export const SET_ORDER_DETAILS_EDITED_STATUS_ATTENDEE = (state, status) => {
  state.order.detailsEdited = status
}

export const SET_ORDER_MENU_EDITED_STATUS_ATTENDEE = (state, status) => {
  state.order.detailsEdited = status
}

export const SET_ORDER_CHARACTERS_EDITED_STATUS_ATTENDEE = (state, status) => {
  state.orderCharacters.edited = status
}

export const SET_ORDER_ATTENDEES_EDITED_STATUS_ATTENDEE = (state, status) => {
  state.orderAttendees.edited = status
}

// Attendee

export const setCurrentSubOrder = (state, order) => {
  state.subOrder.current = order
}

//////////
export const SET_INITIAL_SELECTED_MENU = (state, menu) => {
  state.selectedMenu = menu.map(category => ({
    ...category,
    items: []
  }))
}

export const UPDATE_INITIAL_SELECTED_MENU = (state, menu) => {
  state.selectedMenu = [...menu]
}

export const SELECT_MENU_ITEM_ATTENDEE = (state, data) => {
  const category = state.selectedMenu.find(c => c.id === data.category.id)
  if (category) {
    category.items.push(data.item)
    state.selectedMenu = [...state.selectedMenu]
  }
}

export const UNSELECT_MENU_ITEM_ATTENDEE = (state, data) => {
  const category = state.selectedMenu.find(c => c.id === data.category.id)
  category.items = category.items.filter(item => item.id !== data.item.id)
  state.selectedMenu = [...state.selectedMenu]
}

export const SELECT_ORDER_CHARACTER_ATTENDEE = (state, character) => {
  state.selectedCharacter = character
}

export const setSegmentationOrder = (state, order) => {
  state.segmentationOrder = order
}

export const resetSegmentationOrder = (state) => {
  state.segmentationOrder = {
    uuid            : '',
    process         : null,
    selectedAnswer1 : '',
    selectedAnswer2 : '',
    selectedAnswer3 : '',
    selectedAnswer4 : '',
    locationVerified: false,
    hasCollaborators: false
  }
}

export const setSegmentationQuestions = (state, data) => {
  state.segmentationQuestions = data
}

export const setCurrentEditingOrder = (state, order) => {
  if (order.categories === undefined) {
    order.categories = null
  }
  if (order.characters === undefined) {
    order.characters = null
  }
  if (order.messages === undefined) {
    order.messages = null
  }

  if (order.eventtype === undefined) {
    order.eventtype = null
  }

  if (order.from === undefined) {
    order.from = null
  }

  state.currentEditingOrder = order
}

export const clearCurrentEditingOrder = (state, order) => {
  state.currentEditingOrder = {
    uuid      : '',
    process   : '',
    eventtype : '',
    from      : '',
    categories: null,
    characters: null,
    messages  : null,
    attendees : null,
    last_step : 1
  }
}

export const setCurrentEditingOrderProcess = (state, process) => {
  state.currentEditingOrder.process = process
}

export const setCurrentEditingOrderCaterer = (state, caterer_id) => {
  state.currentEditingOrder.caterer = { id: caterer_id }
}

export const setIsSavingCurrentOrder = (state, isSavingOrder) => {
  state.isSavingCurrentOrder = isSavingOrder
}

export const setIsModalActive = (state, isModalActive) => {
  state.isModalActive = isModalActive
}

// Caterer
export const setCatererDetails = (state, data) => {
  state.catererDetails = data
}

// Event planner
export const setEventPlannerDetails = (state, data) => {
  state.eventPlannerDetails = data
}

// Drawer
export const setDrawerState = (state, data) => {
  state.drawerState = data
}

/**
 * set Manual Line item quantity
 * @param {*} state 
 * @param {Object} data {id: int, quantity: int}
 */
export const SetManualSelectedItemsQuantity = (state, data) => {
  const index = state.manualSelectedItemsQuantity.findIndex(item => {
    return item.id == data.id
  })

  if(index > -1) {
    state.manualSelectedItemsQuantity[index] = data
  } else {
    state.manualSelectedItemsQuantity.push(data)
  }
}

export const SetAllManualSelectedItemsQuantity = (state, data) => {
  state.manualSelectedItemsQuantity = data
}


/**
 * remove manual selected items quantity record by line item id
 * @param {*} state 
 * @param {int} id 
 */
export const DeleteManualSelectedItemsQuantity = (state, id) => {
  const index = state.manualSelectedItemsQuantity.findIndex(item => {
    return item.id == id
  })

  state.manualSelectedItemsQuantity.splice(index, 1)
}

